if (!window.__filmFlixPlusFrontendInitialized) {
    window.__filmFlixPlusFrontendInitialized = true;

    function getCsrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.getAttribute('content') : '';
    }

    function getBaseUrl() {
        const baseMeta = document.querySelector('meta[name="baseUrl"]');
        const baseUrl = baseMeta ? baseMeta.getAttribute('content') : '';
        return baseUrl.replace(/\/$/, '');
    }

    function getFilmFlixPlusUrl() {
        return `${getBaseUrl()}/filmflix-plus`;
    }

    function getUnreadCountUrl() {
        return `${getFilmFlixPlusUrl()}/unread-count`;
    }

    function createUnreadBadge(count) {
        const badge = document.createElement('span');
        badge.className = 'filmflix-plus-menu-badge';
        badge.dataset.filmflixPlusUnreadBadge = '1';
        badge.textContent = count > 99 ? '99+' : String(count);
        return badge;
    }

    function renderUnreadCount(count) {
        document.querySelectorAll('[data-filmflix-plus-unread-badge]').forEach(function (badge) {
            badge.remove();
        });

        if (!Number.isFinite(count) || count <= 0) {
            return;
        }

        document.querySelectorAll('[data-filmflix-plus-menu] > a').forEach(function (link) {
            link.appendChild(createUnreadBadge(count));
        });
    }

    async function refreshFilmFlixPlusUnreadCount() {
        try {
            const response = await fetch(getUnreadCountUrl(), {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();
            renderUnreadCount(Number(data.count || 0));
        } catch (error) {
            console.error(error);
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        refreshFilmFlixPlusUnreadCount();
    });

    document.addEventListener('click', async function (event) {
        const shareButton = event.target.closest('.filmflix-plus-share');

        if (shareButton) {
            const title = shareButton.dataset.shareTitle || '';
            const text = shareButton.dataset.shareText || '';
            const url = shareButton.dataset.shareUrl || window.location.href;
            const originalLabel = shareButton.dataset.shareLabel || '';
            const copiedLabel = shareButton.dataset.copiedLabel || originalLabel;

            if (navigator.share) {
                try {
                    await navigator.share({ title, text, url });
                } catch (error) {
                    if (error && error.name !== 'AbortError') {
                        console.error(error);
                    }
                }
                return;
            }

            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(url);
                    shareButton.childNodes.forEach(function (node) {
                        if (node.nodeType === Node.TEXT_NODE) {
                            node.textContent = ` ${copiedLabel}`;
                        }
                    });

                    window.setTimeout(function () {
                        shareButton.childNodes.forEach(function (node) {
                            if (node.nodeType === Node.TEXT_NODE) {
                                node.textContent = ` ${originalLabel}`;
                            }
                        });
                    }, 1800);
                } catch (error) {
                    console.error(error);
                }
            }

            return;
        }

        const dismissButton = event.target.closest('[data-filmflix-plus-dismiss]');

        if (!dismissButton) {
            return;
        }

        const notice = dismissButton.closest('[data-filmflix-plus-notice]');
        const url = notice ? notice.dataset.dismissUrl : null;

        if (!notice || !url) {
            return;
        }

        dismissButton.disabled = true;

        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': getCsrfToken(),
                },
            });

            if (response.ok) {
                notice.remove();
            } else {
                dismissButton.disabled = false;
            }
        } catch (error) {
            dismissButton.disabled = false;
            console.error(error);
        }
    });
}
